import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './fonts/Alphasmoke-OOX6.ttf';
import './fonts/MckloudBlack-32p.ttf';


const rootElement = document.getElementById('root');
const root = createRoot(rootElement);



root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
